import { Header } from '@procurify/ui'
import styled from 'styled-components'

// Not Sheet.Header: the notice banner below anchors to this row edge to edge.
export const ThreadHeaderRowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`

export const ThreadTitleStyled = styled(Header)`
  && {
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    line-height: 1.33;
    letter-spacing: -0.021em;
  }
`
